document.documentElement.classList.remove('no-js');
const drawer = document.querySelector('[data-mobile-drawer]');
let ddMenuTrigger = null;
function ddOpenMenu(btn) {
  if (!drawer) return;
  ddMenuTrigger = btn;
  drawer.setAttribute('open',''); drawer.setAttribute('aria-hidden','false'); btn?.setAttribute('aria-expanded','true');
  drawer.querySelector('[data-mobile-menu-close]')?.focus();
}
function ddCloseMenu() {
  if (!drawer) return;
  drawer.removeAttribute('open'); drawer.setAttribute('aria-hidden','true'); ddMenuTrigger?.setAttribute('aria-expanded','false'); ddMenuTrigger?.focus();
}
document.querySelectorAll('[data-mobile-menu-open]').forEach(btn => btn.addEventListener('click', () => ddOpenMenu(btn)));
document.querySelectorAll('[data-mobile-menu-close]').forEach(btn => btn.addEventListener('click', ddCloseMenu));
drawer?.addEventListener('click', e => { if (e.target === drawer) ddCloseMenu(); });
drawer?.addEventListener('keydown', e => {
  if (e.key === 'Escape') { e.preventDefault(); ddCloseMenu(); return; }
  if (e.key !== 'Tab') return;
  const focusable = [...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el => el.offsetParent !== null);
  if (!focusable.length) return;
  const first=focusable[0], last=focusable[focusable.length-1];
  if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
});


// Product gallery
 document.querySelectorAll('[data-media-target]').forEach(button => button.addEventListener('click', () => {
  const gallery = button.closest('[data-product-gallery]');
  gallery?.querySelectorAll('[data-product-media]').forEach(media => media.classList.toggle('is-hidden', media.dataset.productMedia !== button.dataset.mediaTarget));
  gallery?.querySelectorAll('[data-media-target]').forEach(thumb => thumb.classList.toggle('is-active', thumb === button));
}));

// Product variant selection. Keeps the native variant select as the source of truth.
document.querySelectorAll('[data-product-section]').forEach(section => {
  const select = section.querySelector('[data-variant-select]');
  const price = section.querySelector('[data-product-price]');
  const add = section.querySelector('[data-add-to-cart]');
  const stock = section.querySelector('[data-stock-label]');
  if (!select) return;
  section.querySelectorAll('.dd-option-pill input').forEach(input => input.addEventListener('change', () => {
    const chosen = [...section.querySelectorAll('.dd-option-group')].map(group => group.querySelector('input:checked')?.value);
    const variantsEl = section.querySelector('[data-product-variants]');
    if (!variantsEl) return;
    const variants = JSON.parse(variantsEl.textContent);
    const variant = variants.find(v => v.options.every((opt, i) => opt === chosen[i]));
    if (!variant) return;
    select.value = String(variant.id);
    select.dispatchEvent(new Event('change', {bubbles:true}));
    const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
  }));
  select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const available = option.dataset.available === 'true';
    if (price) price.textContent = option.dataset.price || '';
    if (add) { add.disabled = !available; add.textContent = available ? 'Add to Cart' : 'Sold Out'; }
    if (stock) { stock.textContent = available ? 'In Stock' : 'Sold Out'; stock.classList.toggle('dd-stock--out', !available); }
  });
});

// Collection filter drawer and sorting
const filters = document.querySelector('[data-filters]');
const filterToggle = document.querySelector('[data-filter-toggle]');
const closeFilters = () => { filters?.classList.remove('is-open'); filterToggle?.setAttribute('aria-expanded','false'); filterToggle?.focus(); };
filterToggle?.addEventListener('click', () => { filters?.classList.add('is-open'); filterToggle.setAttribute('aria-expanded','true'); filters?.querySelector('[data-filter-close]')?.focus(); });
document.querySelector('[data-filter-close]')?.addEventListener('click', closeFilters);
filters?.addEventListener('keydown', e => { if (e.key === 'Escape') closeFilters(); });
document.querySelector('[data-sort-select]')?.addEventListener('change', e => {
  const url = new URL(window.location.href); url.searchParams.set('sort_by', e.target.value); window.location.assign(url.toString());
});

// Phase 5: predictive search using Shopify's locale-aware Predictive Search endpoint.
class DDPredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('#predictive-search');
    this.abortController = null;
    if (!this.input || !this.results) return;
    this.input.addEventListener('input', this.debounce(this.onChange.bind(this), 220));
    this.input.addEventListener('focus', () => { if (this.results.innerHTML.trim()) this.open(); });
    document.addEventListener('click', (event) => { if (!this.contains(event.target)) this.close(); });
    this.addEventListener('keydown', (event) => { if (event.key === 'Escape') this.close(); });
  }
  debounce(fn, wait) { let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), wait); }; }
  async onChange() {
    const term = this.input.value.trim();
    if (term.length < 2) { this.results.innerHTML = ''; this.close(); return; }
    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();
    const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    const url = `${root}search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,collection,page,article,query&resources[limit]=6&section_id=predictive-search`;
    try {
      const response = await fetch(url, { signal: this.abortController.signal });
      if (!response.ok) throw new Error('Predictive search failed');
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const section = doc.querySelector('#shopify-section-predictive-search');
      this.results.innerHTML = section ? section.innerHTML : text;
      this.open();
    } catch (error) {
      if (error.name !== 'AbortError') this.close();
    }
  }
  open() { this.results.hidden = false; this.input.setAttribute('aria-expanded','true'); }
  close() { this.results.hidden = true; this.input.setAttribute('aria-expanded','false'); }
}
if (!customElements.get('predictive-search')) customElements.define('predictive-search', DDPredictiveSearch);

// Phase 6: Ajax quick add and cart-count refresh.
async function ddAddToCart(form) {
  const button = form.querySelector('[data-quick-add-button]');
  const status = form.querySelector('[data-quick-add-status]');
  const card = form.closest('[data-product-card]');
  button?.setAttribute('disabled',''); card?.classList.add('is-adding');
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, { method:'POST', headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, body:new FormData(form) });
    if (!response.ok) throw new Error('Unable to add item');
    const cart = await fetch(`${root}cart.js`).then(r => r.json());
    document.querySelectorAll('.dd-cart-count').forEach(el => el.textContent = cart.item_count);
    card?.classList.add('is-added');
    if (button) button.textContent = 'Added';
    if (status) status.textContent = 'Added to cart';
    ddToast('Added to cart', `${root}cart`, 'View cart');
    setTimeout(() => { if (button) button.textContent = 'Quick Add'; card?.classList.remove('is-added'); }, 1800);
  } catch (error) {
    if (status) status.textContent = 'Could not add to cart. Please try again.';
    ddToast('Could not add to cart');
  } finally { button?.removeAttribute('disabled'); card?.classList.remove('is-adding'); }
}
document.addEventListener('submit', event => { const form = event.target.closest('[data-quick-add-form]'); if (!form) return; event.preventDefault(); ddAddToCart(form); });
function ddToast(message, href, label) {
  document.querySelector('.dd-toast')?.remove();
  const toast = document.createElement('div'); toast.className='dd-toast'; toast.setAttribute('role','status'); toast.textContent=message;
  if (href && label) { const a=document.createElement('a'); a.href=href; a.textContent=label; toast.append(a); }
  document.body.append(toast); setTimeout(()=>toast.remove(),3500);
}

// Related products load from Shopify's Product Recommendations endpoint and Section Rendering response.
document.querySelectorAll('[data-product-recommendations]').forEach(async section => {
  if (!section.dataset.url) return;
  try {
    const response = await fetch(section.dataset.url);
    if (!response.ok) return;
    const text = await response.text();
    const doc = new DOMParser().parseFromString(text,'text/html');
    const fresh = doc.querySelector('[data-product-recommendations]');
    if (fresh && fresh.querySelector('.dd-product-card')) section.innerHTML = fresh.innerHTML;
    else section.remove();
  } catch (_) {}
});

// Recently viewed products. Stores only product handles locally in the visitor's browser.
(async function ddRecentlyViewed(){
  const section = document.querySelector('[data-recently-viewed-section]');
  const current = section?.dataset.currentProduct || document.querySelector('[data-product-section]')?.closest('main')?.dataset?.productHandle;
  const key='dd_recent_products';
  let handles=[]; try { handles=JSON.parse(localStorage.getItem(key)||'[]'); } catch (_) {}
  const pathMatch=window.location.pathname.match(/\/products\/([^/?#]+)/);
  const handle=current || pathMatch?.[1];
  if (handle) { handles=[handle,...handles.filter(h=>h!==handle)].slice(0,10); try { localStorage.setItem(key,JSON.stringify(handles)); } catch (_) {} }
  if (!section) return;
  const display=handles.filter(h=>h!==handle).slice(0,Number(section.dataset.limit||5)); if (!display.length) return;
  const root=window.Shopify?.routes?.root || '/'; const grid=section.querySelector('[data-recently-viewed-grid]');
  const products=(await Promise.all(display.map(async h=>{try{const r=await fetch(`${root}products/${encodeURIComponent(h)}.js`);return r.ok?await r.json():null}catch(_){return null}}))).filter(Boolean);
  if (!products.length) return;
  grid.innerHTML=products.map(p=>{const img=p.featured_image||p.images?.[0]||''; const price=(p.price/100).toLocaleString(undefined,{style:'currency',currency:window.Shopify?.currency?.active||'USD'}); return `<article class="dd-card dd-product-card"><a class="dd-product-card__media-link" href="${root}products/${encodeURIComponent(p.handle)}"><div class="dd-product-card__media">${img?`<img class="dd-product-card__image" src="${img}" loading="lazy" alt="">`:''}</div></a><div class="dd-product-card__body"><h3><a href="${root}products/${encodeURIComponent(p.handle)}">${ddEscape(p.title)}</a></h3><div class="dd-product-card__price">${price}</div></div></article>`}).join('');
  section.hidden=false;
})();
function ddEscape(value){const div=document.createElement('div');div.textContent=value||'';return div.innerHTML;}

// Sticky mobile purchase control mirrors the primary product form and appears after the main button scrolls away.
document.querySelectorAll('[data-product-section]').forEach(section=>{
  const sticky=section.querySelector('[data-sticky-buy]'); const primary=section.querySelector('[data-add-to-cart]'); const form=section.querySelector('[data-product-form]'); const stickyAdd=section.querySelector('[data-sticky-add]');
  if (!sticky||!primary||!form||!stickyAdd) return;
  const observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting},{threshold:0}); observer.observe(primary);
  stickyAdd.addEventListener('click',()=>{ if (!primary.disabled) form.requestSubmit(primary); });
  const select=section.querySelector('[data-variant-select]'); select?.addEventListener('change',()=>{ const option=select.options[select.selectedIndex]; stickyAdd.disabled=option.dataset.available!=='true'; stickyAdd.textContent=stickyAdd.disabled?'Sold Out':'Add to Cart'; const p=sticky.querySelector('[data-sticky-price]'); if(p)p.textContent=option.dataset.price||''; const low=section.querySelector('[data-low-stock]'); const qty=Number(option.dataset.inventory||0); const managed=option.dataset.inventoryManaged==='true'; const threshold=Number(section.dataset.lowStockThreshold||5); if(low){low.classList.toggle('is-hidden',!(managed&&qty>0&&qty<=threshold)); low.textContent=`Only ${qty} left`;}});
});


// Phase 111 — social sharing
document.addEventListener('click', async function(event){
  const nativeButton = event.target.closest('[data-native-share]');
  if(nativeButton){
    const title = nativeButton.dataset.shareTitle || document.title;
    const url = nativeButton.dataset.shareUrl || window.location.href;
    if(navigator.share){
      try { await navigator.share({title, url}); } catch(e) {}
    } else if(navigator.clipboard){
      await navigator.clipboard.writeText(url);
      const label = nativeButton.querySelector('span:last-child');
      if(label){ const old=label.textContent; label.textContent='Copied'; setTimeout(()=>label.textContent=old,1400); }
    }
  }

  const copyButton = event.target.closest('[data-copy-link]');
  if(copyButton){
    const url = copyButton.dataset.shareUrl || window.location.href;
    if(navigator.clipboard){
      await navigator.clipboard.writeText(url);
      const label = copyButton.querySelector('span:last-child');
      if(label){ const old=label.textContent; label.textContent='Copied'; setTimeout(()=>label.textContent=old,1400); }
    }
  }
});

document.addEventListener('input',function(e){
  if(!e.target.matches('[data-strain-directory-search]')) return;
  const q=e.target.value.trim().toLowerCase();
  document.querySelectorAll('[data-strain-nav-item]').forEach(function(item){
    item.hidden=q && !item.textContent.toLowerCase().includes(q);
  });
});

/* Phase 144 — accessible immersive photo gallery */
(function(){
  const root=document.querySelector('[data-dd-photo-gallery]');
  if(!root) return;

  const items=Array.from(root.querySelectorAll('[data-gallery-item]'));
  const filters=Array.from(root.querySelectorAll('[data-gallery-filter]'));
  const lightbox=root.querySelector('[data-gallery-lightbox]');
  const dialog=root.querySelector('[data-gallery-dialog]');
  const main=root.querySelector('[data-gallery-main]');
  const title=root.querySelector('[data-gallery-title]');
  const caption=root.querySelector('[data-gallery-caption]');
  const counter=root.querySelector('[data-gallery-counter]');
  const guideLink=root.querySelector('[data-gallery-link]');
  const thumbs=Array.from(root.querySelectorAll('[data-gallery-thumb]'));
  const prev=root.querySelector('[data-gallery-prev]');
  const next=root.querySelector('[data-gallery-next]');
  const closeButtons=Array.from(root.querySelectorAll('[data-gallery-close]'));
  let index=0;
  let lastFocus=null;
  let touchStartX=null;

  function visibleItems(){
    return items.filter(el=>!el.hidden);
  }

  function show(i){
    const active=visibleItems();
    if(!active.length) return;
    index=(i+active.length)%active.length;
    const item=active[index];
    const globalIndex=Number(item.dataset.index);
    main.src=item.dataset.src;
    main.alt=item.querySelector('img')?.alt || item.dataset.title || 'Gallery image';
    title.textContent=item.dataset.title || '';
    caption.textContent=item.dataset.caption || '';
    counter.textContent=(index+1)+' / '+active.length;
    guideLink.href=item.dataset.link || '#';
    guideLink.textContent='Explore '+(item.dataset.title || 'Species')+' Guide →';
    thumbs.forEach((thumb,thumbIndex)=>{
      const corresponding=items[thumbIndex];
      const isVisible=corresponding && !corresponding.hidden;
      thumb.hidden=!isVisible;
      thumb.classList.toggle('is-active',thumbIndex===globalIndex);
      thumb.setAttribute('aria-current',thumbIndex===globalIndex?'true':'false');
    });
    const currentThumb=thumbs[globalIndex];
    currentThumb?.scrollIntoView({block:'nearest',inline:'center'});
  }

  function openFrom(item){
    lastFocus=document.activeElement;
    const active=visibleItems();
    const local=active.indexOf(item);
    index=Math.max(local,0);
    lightbox.hidden=false;
    lightbox.setAttribute('aria-hidden','false');
    document.body.classList.add('dd-gallery-open');
    show(index);
    dialog.focus();
  }

  function close(){
    lightbox.hidden=true;
    lightbox.setAttribute('aria-hidden','true');
    document.body.classList.remove('dd-gallery-open');
    main.src='';
    lastFocus?.focus();
  }

  items.forEach(item=>item.addEventListener('click',()=>openFrom(item)));
  prev.addEventListener('click',()=>show(index-1));
  next.addEventListener('click',()=>show(index+1));
  closeButtons.forEach(btn=>btn.addEventListener('click',close));
  thumbs.forEach((thumb,globalIndex)=>thumb.addEventListener('click',()=>{
    const active=visibleItems();
    const item=items[globalIndex];
    const local=active.indexOf(item);
    if(local>=0) show(local);
  }));

  filters.forEach(btn=>btn.addEventListener('click',()=>{
    const category=btn.dataset.galleryFilter;
    filters.forEach(x=>x.classList.toggle('is-active',x===btn));
    items.forEach(item=>{
      item.hidden=category!=='all' && item.dataset.category!==category;
    });
  }));

  document.addEventListener('keydown',e=>{
    if(lightbox.hidden) return;
    if(e.key==='Escape'){e.preventDefault();close();}
    if(e.key==='ArrowLeft'){e.preventDefault();show(index-1);}
    if(e.key==='ArrowRight'){e.preventDefault();show(index+1);}
    if(e.key==='Tab'){
      const focusable=Array.from(dialog.querySelectorAll('button:not([hidden]),a[href]:not([hidden])')).filter(el=>el.offsetParent!==null);
      if(!focusable.length) return;
      const first=focusable[0],last=focusable[focusable.length-1];
      if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus();}
    }
  });

  dialog.addEventListener('touchstart',e=>{
    touchStartX=e.changedTouches?.[0]?.clientX ?? null;
  },{passive:true});
  dialog.addEventListener('touchend',e=>{
    if(touchStartX===null) return;
    const end=e.changedTouches?.[0]?.clientX ?? touchStartX;
    const dx=end-touchStartX;
    touchStartX=null;
    if(Math.abs(dx)<45) return;
    show(dx<0?index+1:index-1);
  },{passive:true});
})();
